import { post, get, upload } from '../../config/$ajax.js'
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

export const postAjax = (url, data = {}, params = {}) => {
  return post(API_HOST + url, data, params);
};

// 查询
export const pageList = function(data) {
  return post('/taskCenter/pageList', data, {appJson: true, submitType: 'json'})
}
// 删除
export const batchDeleteTask = function(data) {
  return post('/taskCenter/batchDelete', data, {appJson: true, submitType: 'json'})
}
// 获取平台资料
export const getTaskCenterData = function(data) {
  return get('/taskCenter/detail', data, {appJson: true, submitType: 'json'})
}
// 编辑资料
export const editTaskCenter = function(data) {
  return post('/taskCenter/edit', data, {appJson: true, submitType: 'json'})
}
// 任务重新执行
export const goodsFissionRetry = function(data) {
  return post('/taskCenter/goodsFissionRetry', data, {appJson: true, submitType: 'json'})
}

// 获取AI生图任务明细
export const aiTaskItems = function(data) {
  return get('/taskCenter/goodsFission/aiTaskItems', data)
}

// AI生图子任务重试
export const aiTaskItemRetry = function(data) {
  return post('/taskCenter/goodsFission/aiTaskItemRetry', data, {appJson: true, submitType: 'json'})
}

